import styled from "styled-components"

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: -5px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin: -7.5px;
  }
`

const Item = styled.li`
  padding: 5px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    padding: 7.5px;
  }
`

export const sTags = {
  List,
  Item,
}
